module.exports = __webpack_public_path__ + "img/mv03.4d16226f.jpg";